import {
  FETCH_COURSES_GRADES_BEGIN,
  FETCH_COURSES_GRADES_REJECTED,
  FETCH_COURSES_GRADES_FULFILLED
} from "../actions/coursesActions";

export function studentRatingsReducer(
  state = {
    loading: true,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_COURSES_GRADES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_COURSES_GRADES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_COURSES_GRADES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload.studentRatings
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
export function moduleRatingsReducer(
  state = {
    loading: true,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_COURSES_GRADES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_COURSES_GRADES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_COURSES_GRADES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload.moduleRatings
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
export function avgRatingsReducer(
  state = {
    loading: true,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_COURSES_GRADES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_COURSES_GRADES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_COURSES_GRADES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload.gradeAverage
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
export function studentTotalRatingsReducer(
  state = {
    loading: true,
    result: null,
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_COURSES_GRADES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_COURSES_GRADES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_COURSES_GRADES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload.totalNumberOfGrades
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
